<div
    (mouseenter)="onMouseOverButton($event)"
    (mouseleave)="onMouseOutButton($event)"
>
    <div
        #buttonmenu
        class="ai-button-menu"
        style="visibility: hidden; opacity: 0"
        [style.position]="'fixed'"
        [style.visibility]="
            !!menuElement && isMenuVisible() ? 'visible' : 'hidden'
        "
        [style.opacity]="!!menuElement && isMenuVisible() ? 1 : 0"
        [style.top]="top()"
        [style.left]="left()"
        [style.max-height]="maxHeight()"
        [style.overflow-y]="maxHeight() ? 'auto' : null"
    >
        <ng-content select="ai-menu"></ng-content>
    </div>

    <button
        #button
        [title]="tooltip()"
        [disabled]="disabled()"
        (click)="onButtonClick($event)"
        [type]="type()"
        [ngStyle]="style()"
        [ngClass]="computedClasses()"
    >
        <span
            style="
                display: flex;
                align-items: center;
                justify-content: center;
                width: 100%;
                height: 100%;
                gap: 10px;
            "
        >
            <ng-content select="ai-icon"></ng-content>

            @if (label()) {
                <span>{{ label() }}</span>
            }
        </span>
    </button>
</div>
